import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import PageTitle from '../../../../../shared/javascripts/components/PageTitle/PageTitle'
import asyncWrapper from '../../../../../shared/javascripts/hocs/asyncWrapper'
import Loading from '../../../../../shared/javascripts/components/Loading'
import Breadcrumbs from '../../../../../shared/javascripts/components/Breadcrumbs'
import {receiveTeams} from '../../../../../shared/javascripts/actions/teamActions'


import Charts from '../../../../../shared/javascripts/components/Charts'
import FilterFormContainer from '../../containers/User/FilterFormContainer'
import OverallScore from './Scores/OverallScore'
import OverallMistakes from './Scores/OverallMistakes'
import GenreScore from './Scores/GenreScore'

import UserApi from '../../api/UserApi'

class UserReport extends Component {
  constructor(props) {
    super(props)
    this.state = {
      user: null,
    }
  }

  componentDidMount() {
    // load teams into global state if not already loaded
    if(this.props.teams.length<=0) { this.props.loadTeams() }

    // load this user 
    UserApi.fetchUser(this.props.match.params.userId)
      .then(this.props.handleErrors)
      .then(response => {
        this.setState({user: response},
          ()=> {
            this.props.saveFilterOptions({user_id: this.state.user.id, team_id: this.state.user.team_id, duration: 30});
            this.props.setLoading();
          }
        )
      }).catch(error => console.log(error))
  }

  _findBreadcrumbs() {
    let { match } = this.props;
    let paths = [{name: 'Dashboard', path: '/'}]
    if(match.path.startsWith('/manager/')) { paths.push({name: 'Users', path: '/manager/users'})}

    return paths
  }

  render() {
    if(this.props.loading || this.props.teams.length<=0) { return <Loading />}
    let { user } = this.state;
    const { teams, filterOptions, userActivityCounts } = this.props;
    let breadcrumbPaths = this._findBreadcrumbs()

    return (
      <div className="User">
        <PageTitle title={`Scores for ${user.login}`} rightNav={<Breadcrumbs paths={breadcrumbPaths} />} /><hr />

        <FilterFormContainer user={user} teams={teams} initialValues={{user_id: user.id,team_id: user.team_id, duration: 30}} />

        <div className="ActivityCount">
          <span className="text-info">Total Activities: <span className='badge'>{userActivityCounts.total_activities}</span></span>
          <span className="text-info">Calculated Activities: <span className='badge'>{userActivityCounts.scored_activities}</span></span>
        </div>

        <Charts>
          <OverallScore user={user} filterOptions={filterOptions} saveActivityCounts={this.props.saveActivityCounts} />
          <OverallMistakes user={user} typeName='Category' filterOptions={filterOptions} />
          <OverallMistakes user={user} typeName='Group' filterOptions={filterOptions} />
          <OverallMistakes user={user} typeName='Genre' filterOptions={filterOptions} />
          <GenreScore user={user} filterOptions={filterOptions} />
          <OverallMistakes user={user} typeName='Value' filterOptions={filterOptions} />
        </Charts>
      </div>
    );
  }
}

export default asyncWrapper(withRouter(UserReport))


// WEBPACK FOOTER //
// ./src/reports/general/javascripts/components/User/UserReport.jsx